export const mockComplianceData = [
  {
    areaName: 'Washington, DC Metro Area',
    totalEmployees: 71,
    totalSites: 3,
    compliantSites: 2,
    worksites: [
      {
        name: '2240 6th St. NW Washington DC 20059',
        employeeCount: 15,
        isCompliant: true,
      },
      {
        name: '600 New Jersey Ave NW Washington DC 20001',
        employeeCount: 7,
        isCompliant: true,
      },
      {
        name: '3700 O St NW Washington DC 20057',
        employeeCount: 49,
        isCompliant: false,
      },
    ],
    complianceRequirements: [
      {
        text: 'Employers with 20+ employees must offer commuter or transit benefits',
      },
      { text: 'TDM Plan required for sites >100 employees' },
      { text: 'Transit subsidy minimum: $100/month' },
      { text: 'Annual reporting required' },
    ],
  },
  {
    areaName: 'Chicago, IL Metro Area',
    totalEmployees: 102,
    totalSites: 1,
    compliantSites: 0,
    worksites: [
      {
        name: '225 W Hubbard St Chicago IL 60654',
        employeeCount: 102,
        isCompliant: false,
      },
    ],
    complianceRequirements: [
      {
        text: 'Employers with 50+ employees must offer commuter or transit benefits',
      },
      { text: 'TDM Plan required for sites >100 employees' },
      { text: 'Transit subsidy minimum: $100/month' },
      { text: 'Annual reporting required' },
    ],
  },
  {
    areaName: 'New York City Metro Area',
    totalEmployees: 1,
    totalSites: 1,
    compliantSites: 1,
    worksites: [
      {
        name: '1450 Broadway, Suite 11-101 New York NY 10018',
        employeeCount: 1,
        isCompliant: true,
      },
    ],
    complianceRequirements: [
      {
        text: 'Employers with 20+ employees must offer commuter or transit benefits',
      },
      { text: 'TDM Plan required for sites >100 employees' },
      { text: 'Transit subsidy minimum: $130/month' },
      { text: 'Quarterly reporting required' },
    ],
  },
  {
    areaName: 'Bay Area, CA Metro Area',
    totalEmployees: 12,
    totalSites: 1,
    compliantSites: 1,
    worksites: [
      {
        name: '500 12th Street Suite 300 Oakland CA 94607',
        employeeCount: 12,
        isCompliant: true,
      },
    ],
    complianceRequirements: [
      {
        text: 'Employers with 50+ employees must offer commuter benefits and report compliance',
      },
      { text: 'TDM Plan required for sites >100 employees' },
      { text: 'Transit subsidy minimum: $100/month' },
      { text: 'Annual reporting required' },
    ],
  },
  {
    areaName: 'Colorado Metro Area',
    totalEmployees: 55,
    totalSites: 2,
    compliantSites: 2,
    worksites: [
      {
        name: '1003 Vasquez St Golden CO 80401',
        employeeCount: 26,
        isCompliant: true,
      },
      {
        name: '11400 Westmoor Circle Suite 220 Westminster CO 80021',
        employeeCount: 29,
        isCompliant: true,
      },
    ],
    complianceRequirements: [
      {
        text: 'No mandate - Colorado offers employers a 50% tax credit, up to $250,000, for providing commuter benefits to employees',
      },
      { text: 'Voluntary participation encouraged' },
      { text: 'Tax credit available for qualifying commuter benefits' },
      { text: 'Annual reporting for tax credit eligibility' },
    ],
  },
]
